const private_network = {
	index: {
		empty: {
			description: "Uw account beschikt nog niet over private networks.",
			title: "Geen private networks aangetroffen...",
		},
		notifications: {
			create: "Private network <strong>{{name}}</strong> wordt aangemaakt... Dit kan even duren.",
			create_already_existing:
				"Private network <strong>{{name}}</strong> kan niet aangemaakt worden. Deze naam is al in gebruik.",
			delete: "Private network <strong>{{name}}</strong> is succesvol verwijderd.",
			update: "Private network <strong>{{name}}</strong> is succesvol gewijzigd.",
			update_already_existing:
				"Private network <strong>{{name_current}}</strong> kan niet gewijzigd worden. Er is al een private network met naam <strong>{{name_new}}</strong>.",
		},
		search: {
			label: "Private network zoeken",
			placeholder: "Netwerk X",
		},
		title: "Overzicht van private networks",
	},
	management: {
		dialog_create: {
			description: "Voeg hier uw nieuwe private network toe.",
			title: "Private network toevoegen",
		},
		dialog_delete: {
			description: `Weet u zeker dat u het private network <strong>{{name}}</strong> wilt verwijderen? 
				<br/>
				<br/>
				<strong>Let op!</strong>
				Alle gekoppelde VPS'en worden ontkoppeld en de overbodige interfaces worden uit deze VPS'en verwijderd.`,
			title: "Private network verwijderen",
		},
		dialog_qemu_connect: {
			button: "VPS'en selecteren",
			description: "Selecteer een van uw VPS’en die nog niet gekoppeld is aan een netwerk.",
			no_internet_connection: "Geen internet verbinding",
			title: "VPS toevoegen aan netwerk",
		},
		dialog_qemu_delete: {
			description:
				"Weet u zeker dat u VPS <strong>{{name}}</strong> wilt verwijderen uit het netwerk?",
			title: "VPS verwijderen uit netwerk.",
		},
		dialog_qemu_select: {
			costs: "Prijs € {{costs}} p/m",
			description:
				"Hier bevinden zich de VPS'en die gekoppeld kunnen worden aan het private network.",
			empty: {
				title: "Geen beschikbare VPS'en gevonden.",
				tooltip:
					"Er zijn geen VPS'en aangetroffen die nog niet verbonden zijn aan een private network. Verwijder VPS'en eerst uit een ander private network of voeg nieuwe VPS'en toe.",
			},
			title: "Selecteer een beschikbare VPS",
		},
		info: {
			title: "Kenmerken",
		},
		notifications: {
			create: "De geselecteerde VPS'en zijn succesvol toegevoegd aan het private network.",
			delete: "VPS <strong>{{name}}</strong> is succesvol verwijderd uit het netwerk.",
		},
		qemus: {
			description:
				"Koppel VPS'en aan elkaar middels een private network. De VPS krijgt hiervoor een aparte netwerk interface. VPS'en die in hetzelfde netwerk staan kunnen met elkaar communiceren. U hoeft alleen IP-adressen te configureren op deze interne interface.",
			table: {
				connection: ["Ja", "Nee"],
				empty: "Geen VPS'en aangetroffen binnen netwerk.",
				header: ["VPS", "Status", "Internet verbinding?"],
				status: ["Running", "Stopped"],
			},
			title: "VPS'en in netwerk",
		},
		title: "Private network",
	},
	overview_card: {
		description: "Omschrijving",
		name: "Naam",
	},
};

export default private_network;
